module.exports = __webpack_public_path__ + "static/profile-fcaf88200e0e4e44d9a9f9fe06e97832.jpg";